import { Flex } from '@sequencehq/core-components'
import { useMemo } from 'react'

import { ScopeProvider } from 'jotai-scope'
import { QuoteSummary, quoteDataAtom } from '@sequencehq/quote-content'
import { TaskInput } from '../../types'
import { toQuoteRendererData } from './utils'

export const QuoteReviewSummary = (props: { taskInput: TaskInput }) => {
  const { quote, customer } = props.taskInput

  const quoteData = useMemo(
    () => toQuoteRendererData({ quote, customer }),
    [quote, customer]
  )

  return (
    <Flex padding="16px" overflowY="auto" height="100%">
      <ScopeProvider atoms={[[quoteDataAtom, quoteData]]}>
        <QuoteSummary
          currentUserEmail={undefined}
          footer={undefined}
          variant="bare"
        />
      </ScopeProvider>
    </Flex>
  )
}
